import { RouterGuard } from '@/services/router/types';

/**
 * Handle development routes.
 */
export const developmentGuard: RouterGuard = function developmentGuard(to, from, next) {
  if (to.name && /^development/.test(String(to.name)) && this.routeHasAccess(to)) {
    next(true);
  }
  else {
    next();
  }
};
